import { createAction } from 'redux-actions';

export const FETCH_ENTRIES = 'FETCH_ENTRY';
export const SET_ENTRIES = 'SET_ENTRIES';
export const SET_INVITE = 'SET_INVITE';
export const SET_ROUTINES_CAMPAIGN = 'SET_ROUTINES_CAMPAIGN';
export const SET_TEMPLATE = 'SET_TEMPLATE';

export const setEntries = createAction(SET_ENTRIES);

export const setInvite = createAction(SET_INVITE);

export const setRoutinesCampaign = createAction(SET_ROUTINES_CAMPAIGN);

export const setTemplate = createAction(SET_TEMPLATE);
